class InterviewSwiper {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);
    this.swiper = null;

    if (!this.root) {
      return;
    }

    this.mq = window.matchMedia('(max-width: 767px)');
    this.handleChange = this.handleChange.bind(this);
    this.onImagesReady = this.onImagesReady.bind(this);

    this.handleChange();

    if (this.mq.addEventListener) {
      this.mq.addEventListener('change', this.handleChange);
    } else {
      this.mq.addListener(this.handleChange);
    }

    if (document.readyState === 'complete') {
      this.onImagesReady();
    } else {
      window.addEventListener('load', this.onImagesReady, { once: true });
    }
  }

  onImagesReady() {
    if (!this.swiper) {
      return;
    }

    this.swiper.update();
  }

  handleChange() {
    if (this.mq.matches) {
      this.init();
    } else {
      this.destroy();
    }
  }

  getSpaceBetweenPx() {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (Number.isNaN(rootFontSize)) {
      return 16;
    }

    // SP カード間 gap 16px（Figma）
    return rootFontSize * 1.6;
  }

  init() {
    if (this.swiper) {
      return;
    }
    if (!this.root) {
      return;
    }
    if (typeof Swiper === 'undefined') {
      return;
    }

    const paginationEl = this.root.querySelector('.p-top__interview-pagination');
    const prevEl = this.root.querySelector('.p-top__interview-prev');
    const nextEl = this.root.querySelector('.p-top__interview-next');

    this.swiper = new Swiper(this.root, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: this.getSpaceBetweenPx(),
      observer: true,
      observeParents: true,
      resistanceRatio: 0,
      allowTouchMove: true,
      touchStartPreventDefault: false,
      pagination: paginationEl
        ? {
            el: paginationEl,
            type: 'fraction',
          }
        : undefined,
      navigation:
        prevEl && nextEl
          ? {
              prevEl,
              nextEl,
            }
          : undefined,
    });

    requestAnimationFrame(() => {
      if (this.swiper) {
        this.swiper.update();
      }
    });
  }

  destroy() {
    if (!this.swiper) {
      return;
    }

    try {
      // deleteInstance=true / cleanStyles=true（Swiperのバージョン差異対策）
      this.swiper.destroy(true, true);
    } catch (e) {
      this.swiper.destroy();
    }

    this.swiper = null;
  }
}

